import React from "react";
import TotalPlaytime from "../../TotalPlaytime";

const Screen32 = () => {
    return <TotalPlaytime />;
};

export default Screen32;
